export default {
  navDashboard: 'Dashboard',
  navRoster: 'Roster',
  navRosterDesc: 'Weekly jobs and crew by site',
  navSwaps: 'Swap requests',
  navSwapsDesc: 'Approve shift swaps between crew',
  navLeave: 'Leave',
  navLeaveDesc: 'Leave requests and balances',
  navTimesheets: 'Timesheets',
  navReports: 'Reports',
  navReportsDesc: 'Who was on site, and for how long',
  navJobCosts: 'Job costs',
  navJobCostsDesc: 'Labour cost per job and per person',
  navSites: 'Sites',
  navSitesDesc: 'Job sites, geofences and addresses',
  navEmployees: 'Employees',
  navEmployeesDesc: 'People, portal logins and site assignments',
  navOrgChart: 'Org chart',
  navOrgChartDesc: 'Sites, managers and who reports to them',
  navPerformance: 'Performance',
  navPerformanceDesc: 'Reviews, goals and review criteria',
  navAssets: 'Assets',
  navAssetsDesc: 'Company equipment and who has it',
  navBeacons: 'Beacons',
  navBeaconsDesc: 'Bluetooth tags and site gateways',
  navChecklists: 'Checklists',
  navChecklistsDesc: 'Onboarding and offboarding task lists',
  navChat: 'Chat',
  navChatDesc: 'Direct and group messages with your crew',
  navChatReview: 'Chat review',
  navChatReviewDesc: 'Search, read and export every conversation',
  navSettings: 'Settings',
  navSettingsDesc: 'Company preferences and timezone',
  navBilling: 'Billing',
  navBillingDesc: 'Your subscription and seat count',
  navSuperDashboardDesc: 'Platform overview',
  navCompanies: 'Companies',
  navCompaniesDesc: 'Every company on the platform',
  navSuperBillingDesc: 'Subscriptions and MRR across every tenant',
  navResellers: 'Resellers',
  navResellersDesc: 'Reseller applications and approvals',
  navHardware: 'Hardware',
  navHardwareDesc: 'Beacons, gateways and sensors: stock, orders, assignment',
  navResellerHardwareDesc: 'Order beacons, gateways and sensors',
  navUsers: 'Users',
  navUsersDesc: 'All platform users',
  navProfile: 'Profile',
  navProfileDesc: 'Your account',
  navResellerDashboardDesc: 'Referred companies and commission earned',
  navListing: 'Directory listing',
  navListingDesc: 'Your entry in the public reseller directory',
  navPayout: 'Payout account',
  navPayoutDesc: 'Payout account setup',
  groupManage: 'Manage',
  groupPlatform: 'Platform',
  rolePlatformAdmin: 'Platform admin',
  roleAdmin: 'Admin',
  roleSiteManager: 'Site manager',
  roleReseller: 'Reseller',
  skipToContent: 'Skip to content',
  primaryNav: 'Primary',
  sectionNav: '{section} section',
  signOut: 'Sign out',
  impersonating: "Viewing <b>{company}</b> as <b>{admin}</b>. You're signed in as super admin {superAdmin}.",
  exitImpersonation: 'Exit and sign out',
  timezoneHint: "All times are shown in your browser's local time zone unless noted otherwise",
}
